
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { BlogCategory } from "@/types/blogPost";
import { CategoryForm, CategoryFormData } from "./CategoryForm";
import { CategoryList } from "./CategoryList";
import { useCategoryOperations } from "@/hooks/useCategoryOperations";

export function BlogCategoryManager() {
  const [isCreating, setIsCreating] = useState(false);
  const [editingCategory, setEditingCategory] = useState<BlogCategory | null>(null);
  
  const {
    categories,
    fetchCategories,
    createCategory,
    updateCategory,
    deleteCategory,
  } = useCategoryOperations();

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const handleSubmit = async (formData: CategoryFormData) => {
    try {
      if (editingCategory) {
        await updateCategory(editingCategory.id, formData);
      } else {
        await createCategory(formData);
      }
      handleCancel();
    } catch (error) {
      // Error handling is done in the hook
    }
  };

  const handleEdit = (category: BlogCategory) => {
    setEditingCategory(category);
    setIsCreating(true);
  };

  const handleCancel = () => {
    setIsCreating(false);
    setEditingCategory(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Categorias do Blog</h3>
        {!isCreating && (
          <Button onClick={() => setIsCreating(true)} size="sm">
            <Plus className="w-4 h-4 mr-2" />
            Nova Categoria
          </Button>
        )}
      </div>

      {isCreating && (
        <CategoryForm
          editingCategory={editingCategory}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}

      <CategoryList
        categories={categories}
        onEdit={handleEdit}
        onDelete={deleteCategory}
      />
    </div>
  );
}
